import { ContainerComponent, wrap } from "AppReact";
import Controller from "./controller";
import {
  RoundedFilterHeaderWrapper,
  WhiteSpaceNoWrap,
  Mr3,
  Mb2,
  Mt2,
  GenericWrapper,
  FitRelativeWrapper,
  AbsoluteLeftTopWrapper,
  CustomBorderWrapper,
  FlexCenterBetweenWrapper,
  Px3,
  Mt4,
  P3,
  Mr2,
  CustomHeight,
  FullWIdthColumnScrollWrapper,
  PrimaryBackground50Wrapper,
  FullWidthFlexBoxWrapper,
  MaxWidthHeight,
  FlexCenterWrapper,
  FullWidthJustifyEndWrapper,
} from "wrappers";
import internalState from "./internalState";
import {
  SecondaryTextSm,
  BorderlessInput,
  Icon,
  SecondaryTextXs,
  WhiteTextXs,
} from "atoms";
import { MagnifyingGlassSvg, DownCaretSvg } from "components/icons";
import { TextButton, PropertyButton } from "molecules";
import { Options } from "./molecules";
import { textEllipsis } from "utils/ellipsis";
import { escapedRegex } from "utils";
import { SelectedValuesWrapper } from "./wrappers";

export const definition = {
  name: "SimpleMultiSelector",
  controller: Controller,
  initialProps: ({
    options,
    selectedIds,
    label,
    isReadonly,
    singleSelect,
    headerWidth,
    searchPlaceholder,
    selectedName,
  }) => ({
    options,
    selectedIds,
    label,
    isReadonly,
    singleSelect,
    headerWidth,
    searchPlaceholder,
    selectedName,
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: "Wrapper",
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: RoundedFilterHeaderWrapper,
          name: "Header",
          isButton: true,
          displayState: ({ isReadonly, selectedIds, isOpen, headerWidth }) => ({
            disabled: isReadonly,
            completed: selectedIds.length > 0 && !isOpen,
            width: headerWidth,
          }),
          bindings: ({
            isOpen,
            isReadonly,
            selectedIds,
            containerRef,
            inputRef,
          }) => ({ isOpen, containerRef, isReadonly, inputRef, selectedIds }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSm, WhiteSpaceNoWrap), Mr3),
              renderIf: ({ isOpen }) => !isOpen,
              displayValue: ({ label, selectedIds, selectedName }) => {
                if (selectedIds.length > 0) {
                  return selectedName ?? "Selected";
                }
                return label ?? "Filter by";
              },
            },
            {
              wrapper: GenericWrapper,
              name: "SearchWrapper",
              ref: ({ inputRef }) => inputRef ?? null,
              elements: [
                {
                  component: wrap(BorderlessInput, Mr3),
                  name: "SearchInput",
                  renderIf: ({ isOpen }) => isOpen,
                  displayState: ({ searchPlaceholder }) => ({
                    width: searchPlaceholder ? "150px" : "114px",
                    minWidth: "114px",
                  }),
                  bindings: ({ searchTerm, searchPlaceholder }) => ({
                    value: searchTerm,
                    placeholder: searchPlaceholder ?? "Search...",
                  }),
                },
              ],
            },
            {
              wrapper: wrap(SelectedValuesWrapper, Mr2),
              name: "SelectedValues",
              renderIf: ({ selectedIds, isOpen, singleSelect }) =>
                !singleSelect && selectedIds.length > 0 && !isOpen,
              elements: [
                {
                  component: WhiteTextXs,
                  name: "Count",
                  displayValue: ({ selectedIds }) => `${selectedIds.length} `,
                },
              ],
            },
            {
              component: wrap(Icon, FullWidthJustifyEndWrapper),
              name: "Icon",
              displayValue: ({ isOpen }) =>
                isOpen
                  ? MagnifyingGlassSvg({ color: "#C2CCCE" })
                  : DownCaretSvg({ color: "#C2CCCE" }),
            },
          ],
        },

        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({}) => ({ top: "50px" }),
          renderIf: ({ isOpen }) => isOpen,
          name: "DropdownWrapper",
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: "BorderWrapper",
              displayState: ({}) => ({
                borderRadius: "8px",
                border: "1px solid #E3E3E3",
                background: "#FFFFFF",
              }),
              elements: [
                {
                  wrapper: wrap(P3, PrimaryBackground50Wrapper),
                  renderIf: ({ selectedIds, singleSelect }) =>
                    !singleSelect && selectedIds.length > 0,
                  name: "ButtonsWrapper",
                  elements: [
                    {
                      wrapper: MaxWidthHeight,
                      name: "ListWrapper",
                      displayState: ({}) => ({
                        height: "52px",
                        width: "100%",
                        display: "flex",
                      }),
                      elements: [
                        {
                          wrapper: wrap(
                            wrap(
                              FullWidthFlexBoxWrapper,
                              FullWIdthColumnScrollWrapper
                            ),
                            FlexCenterWrapper
                          ),
                          name: "ButtonsWrapper",
                          elements: [
                            {
                              component: wrap(wrap(PropertyButton, Mr2), Mt2),
                              name: "SelectedValueButton",
                              isListOf: "selectedIds",
                              bindings: ({
                                options,
                                selectedId,
                                selectedIds,
                              }) => ({
                                selectedId,
                                selectedIds,
                                name: options.find((p) => p.id === selectedId)
                                  ?.name,
                              }),
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  wrapper: wrap(
                    wrap(wrap(FlexCenterBetweenWrapper, Px3), Mt4),
                    Mb2
                  ),
                  name: "ClearAllHeader",
                  renderIf: ({ singleSelect }) => !singleSelect,
                  elements: [
                    {
                      component: SecondaryTextXs,
                      name: "SelectedText",
                      displayValue: ({ selectedIds }) =>
                        `${selectedIds.length ?? 0} Selected`,
                    },
                    {
                      component: TextButton,
                      name: "ClearAll",
                      bindings: ({ selectedIds, options }) => ({
                        small: true,
                        mobileSmall: true,
                        selectedIds,
                        options,
                        title:
                          (selectedIds.length ?? 0) > 0
                            ? "Clear all"
                            : "Select all",
                      }),
                    },
                  ],
                },
                {
                  wrapper: CustomHeight,
                  name: "ListWrapper",
                  displayState: ({ headerWidth }) => ({
                    height: 270,
                    width: headerWidth ? headerWidth : "300px",
                  }),
                  elements: [
                    {
                      wrapper: FullWIdthColumnScrollWrapper,
                      name: "ListWrapper",
                      elements: [
                        {
                          component: wrap(Options, Mt2),
                          name: "OptionsList",
                          isListOf: "options",
                          renderIf: ({ option, searchTerm }) =>
                            escapedRegex(searchTerm).test(option.name),
                          bindings: ({
                            option,
                            selectedIds,
                            singleSelect,
                            headerWidth,
                          }) => {
                            const isSelected = selectedIds.includes(option.id);
                            return {
                              icon: option?.icon ?? "",
                              name: headerWidth
                                ? textEllipsis(option.name, 20)
                                : option.name,
                              id: option.id,
                              isSelected,
                              selectedIds,
                              singleSelect,
                            };
                          },
                          displayState: ({ selectedIds, option }) => {
                            const isSelected = selectedIds.includes(option.id);
                            return { isSelected };
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default ContainerComponent(definition);
